import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction, from } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { MyProfileForm } from '@dtp/membership-service-types';
import { toReduxError } from '@universal/errors';
import { ProfileUpdate } from '@appTypes/profileType';
import { Actions, actions } from '@redux/modules/myProfile';
import { TypedEpic } from './types';

export const getProfileEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_PROFILE),
    withLatestFrom(state$) as unknown as OperatorFunction<Action<any>, ActionType<typeof actions.getProfile.request>[]>,
    switchMap(() =>
      fromApiRequest((signal) =>
        apiClient.get<MyProfileForm>(ApiType.apimMembershipApi, {
          signal,
          url: ApiPaths[ApiType.apimMembershipApi].profile,
        }),
      ).pipe(
        map((response) => actions.getProfile.success(response.data)),
        catchError((err) =>
          of(
            actions.getProfile.failure(
              toReduxError(
                err,
                'Beklager, vi har motorproblemer... Kunne ikke hente profilen! Kontakt kundesenteret hvis problemet vedvarer!',
              ),
            ),
          ),
        ),
      ),
    ),
  );

export const editProfileEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.EDIT_PROFILE),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.editProfile.request>[]
    >,
    switchMap(([action]) =>
      from(
        apiClient.post<ProfileUpdate>(ApiType.apimMembershipApi, {
          url: ApiPaths[ApiType.apimMembershipApi].profile,
          data: action.payload,
        }),
      ).pipe(
        map((response) => actions.editProfile.success(response.data)),
        catchError(({ response }) => of(actions.editProfile.failure(response?.validation))),
      ),
    ),
  );

export const editEmailEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.EDIT_EMAIL),
    withLatestFrom(state$) as unknown as OperatorFunction<Action<any>, ActionType<typeof actions.editEmail.request>[]>,
    switchMap(([action]) =>
      from(
        apiClient.post<{ email: string }>(ApiType.apimMembershipApi, {
          url: ApiPaths[ApiType.apimMembershipApi].email,
          data: action.payload,
        }),
      ).pipe(
        map((response) => actions.editEmail.success(response.data)),
        catchError(({ response }) => of(actions.editEmail.failure(response?.validation))),
      ),
    ),
  );

export const epics: TypedEpic[] = [getProfileEpic, editProfileEpic, editEmailEpic];
